<template>
  <v-container grid-list-md text-xs-center>
    <LoadingDialog v-if="loading" v-model="loading" />
    <v-layout v-else row wrap>
      <BackButton />
      <v-flex xs12 sm4>
        <UserSidebar :activeMenu="activeMenu" @changeMenu="activeMenu = $event">
          <a
            v-if="userData && userData.document && userData.document.photo"
            :href="`${photoUrl}/${userData.document.photo}`"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ImgLazyLoad
              :src="`${photoUrl}/${userData.document.photo}`"
              class="profileImage"
            />
          </a>
          <!-- <v-icon color="indigo">
            {{
              userData && userData.borrower_status == 1
                ? "check_box"
                : "check_box_outline_blank"
            }}
          </v-icon> -->
        </UserSidebar>
      </v-flex>
      <v-flex xs12 sm8>
        <UserDetailsBasicInfo
          v-if="userData && userData.basic_info && activeMenu == '1'"
          :userData="userData"
        />
        <UserDetailsProfessionalInfo
          v-if="userData && userData.professional_info && activeMenu == '2'"
          :professionalInfo="userData"
        />

        <UserDetailsDocuments
          v-if="userData && userData.document && activeMenu == '3'"
          :documents="userData.document"
        />

        <UserDetailsBankDetails
          v-if="userData && userData.bank_detail && activeMenu == '4'"
          :bankDetails="userData.bank_detail"
        />

        <UserDetailsLoanHistory
          v-if="activeMenu == '6'"
          :userId="userData.id"
        />
        <!-- <pre v-if="userData">{{ userData }}</pre> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import LoadingDialog from "@/components/Dialogs/LoadingDialog";
  import UserSidebar from "@/components/UserSidebar";
  import UserDetailsBasicInfo from "@/components/UserDetailsBasicInfo";
  import UserDetailsProfessionalInfo from "@/components/UserDetailsProfessionalInfo";
  import UserDetailsDocuments from "@/components/UserDetailsDocuments";
  import UserDetailsBankDetails from "@/components/UserDetailsBankDetails";
  import UserDetailsLoanHistory from "@/components/UserDetailsLoanHistory";
  import HTTP from "@/utils/HTTP";
  import { investeeAllDataUrl } from "@/utils/variables";
  import BackButton from "@/components/BackButton";
  import ImgLazyLoad from "@/components/ImgLazyLoad";

  export default {
    components: {
      LoadingDialog,
      UserSidebar,
      UserDetailsBasicInfo,
      UserDetailsProfessionalInfo,
      UserDetailsDocuments,
      UserDetailsBankDetails,
      UserDetailsLoanHistory,
      BackButton,
      ImgLazyLoad,
    },

    data() {
      return {
        userData: [],
        loading: true,
        activeMenu: 1,
        photoUrl: process.env.VUE_APP_PHOTO_URL,
      };
    },

    created() {
      this.initialize();
    },

    methods: {
      async initialize() {
        try {
          const { data } = await HTTP().get(
            `${investeeAllDataUrl}?query=${this.$route.params.mobile}&page=1&per_page=1`
          );
          this.userData = data.data.data[0];
          //   this.totalUsers = data.data.total;
          this.loading = false;
        } finally {
          //   this.loading = false;
        }
      },
    },
  };
</script>
<style scoped>
  .profileImage {
    max-width: 150px;
    max-height: 350px;
  }
</style>
